module.exports = __webpack_public_path__ + "static/media/check-tick.ed50f2a4.svg";